import { MantineMenu } from '@dealstack/frontend/shared/components/MantineMenu/MantineMenu.tsx';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { Menu } from '@mantine/core';
import { useMemo } from 'react';
import { MantineMenuItemProps } from '@dealstack/frontend/shared/components/MantineMenu/MantineMenu.types';
import { FloatingLabel, InnermostCircle, InnerRing, NodeWrapper } from './styled';

interface Props {
	color: string;
	label?: string;
	contextMenuHeader: string;
	contextMenuItems?: string[];
}

/**
 * Renders a node graphic consisting of concentric circles with borders.
 */
export const BlockNode = ({ color, label, contextMenuItems, contextMenuHeader }: Props) => {
	const mappedItems: MantineMenuItemProps[] = useMemo(
		() =>
			(contextMenuItems || []).map((item, index) => ({
				key: `${item}-${index}`,
				label: item,
				disabled: true,
			})),
		[contextMenuItems]
	);

	return (
		<NodeWrapper $color={color}>
			<MantineMenu
				dataTestId={TEST_ELEMENT_IDS.BLOCK_NODE}
				items={mappedItems}
				menuProps={{
					withinPortal: true,
				}}
				menuDropdownProps={{
					w: 'auto',
					miw: 200,
				}}
				targetButtonProps={{
					p: 0,
					radius: '50%',
					disabled: !mappedItems.length,
					style: {
						opacity: 1,
						zIndex: 1,
					},
				}}
				hideArrow
				targetContent={
					<InnerRing color={color} $allowContextMenu={!!mappedItems.length}>
						<InnermostCircle color={color} />
					</InnerRing>
				}
				dropdownTopContent={
					contextMenuHeader ? (
						<>
							<Menu.Label
								p="0"
								c="dark.8"
								fz="md"
								fw={600}
								style={{ textAlign: 'center' }}
							>
								{contextMenuHeader}
							</Menu.Label>
							<Menu.Divider />
						</>
					) : undefined
				}
			></MantineMenu>
			{label ? (
				<FloatingLabel c={color} fw={600}>
					{label}
				</FloatingLabel>
			) : null}
		</NodeWrapper>
	);
};
